// // src/pages/RRCheckPoints.jsx
import React, { useEffect, useMemo, useState, useCallback } from "react";
import axiosInstance from "../axiosConfig";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

function RRCheckPoints() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

  const user = JSON.parse(localStorage.getItem("userData"));
  const person = (user?.Name || "").trim();
   const [pendingId, setPendingId] = useState(null); // disable a row while saving
  // replace your todayStr memo with IST day

  //   const todayStr = useMemo(() => {
  //     const d = new Date();
  //     const yyyy = d.getFullYear();
  //     const mm = String(d.getMonth() + 1).padStart(2, '0');
  //     const dd = String(d.getDate()).padStart(2, '0');
  //     return `${yyyy}-${mm}-${dd}`;
  //   }, []);

  // --- helpers (put near top of file) ---
  const toISTDateTime = (isoOrDate) => {
    if (!isoOrDate) return "";
    const d = typeof isoOrDate === "string" ? new Date(isoOrDate) : isoOrDate;
    // dd/mm/yyyy, HH:MM:SS in IST (24h)
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(d);
  };

  const todayIST = () => {
    // returns YYYY-MM-DD for IST day boundary, so your /rr/today uses the correct date
    const ist = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );
    const y = ist.getFullYear();
    const m = String(ist.getMonth() + 1).padStart(2, "0");
    const d = String(ist.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const todayStr = useMemo(() => todayIST(), []);

  //   const loadData = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await axiosInstance.get('/api/rr/today', {
  //         params: { person, date: todayStr }
  //       });
  //       setItems(res.data || []);
  //     } catch (e) {
  //       console.error(e);
  //       setItems([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   useEffect(() => { loadData(); }, [person, todayStr]);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/api/rr/today", {
        params: { person, date: todayStr },
      });
      setItems(res.data || []);
    } catch (e) {
      console.error(e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [person, todayStr]); // deps here

  useEffect(() => {
    loadData();
  }, [loadData]); // safe now

  const toggleSidebar = () => setIsSidebarVisible((v) => !v);

//   const handleToggle = async (row, newChecked) => {
//     // optimistic UI
//     setItems((prev) =>
//       prev.map((it) =>
//         it.ResponsibilityId === row.ResponsibilityId
//           ? {
//               ...it,
//               Checked: newChecked ? 1 : 0,
//               CheckedBy: newChecked ? person : null,
//               CheckedAt: newChecked ? new Date().toLocaleString() : null,
//             }
//           : it
//       )
//     );

//     try {
//       await axiosInstance.patch("/api/rr/check", {
//         responsibilityId: row.ResponsibilityId,
//         workDate: row.WorkDate,
//         checked: !!newChecked,
//         user: person,
//       });
//       // Optionally reload to be 100% in sync:
//       // await loadData();
//     } catch (e) {
//       console.error("Failed to toggle checkpoint", e);
//       // revert on error
//       setItems((prev) =>
//         prev.map((it) =>
//           it.ResponsibilityId === row.ResponsibilityId
//             ? {
//                 ...it,
//                 Checked: row.Checked,
//                 CheckedBy: row.CheckedBy,
//                 CheckedAt: row.CheckedAt,
//               }
//             : it
//         )
//       );
//       alert("Failed to update, please try again.");
//     }
//   };

  // with confirmation
  const handleToggle = async (row, newChecked, evt) => {
    const currentlyChecked = row.Checked === 1;
    const wantToCheck = !!newChecked;

    // confirmation message
    const msg = wantToCheck
      ? `Mark this checkpoint as DONE?\n\n"${row.Responsibility}"`
      : `Mark this checkpoint as PENDING again?\n\n"${row.Responsibility}"`;

    if (!window.confirm(msg)) {
      // prevent visual flicker (revert checkbox immediately)
      if (evt && evt.target) evt.target.checked = currentlyChecked;
      return;
    }

    // optimistic UI
    setPendingId(row.ResponsibilityId);
    setItems(prev => prev.map(it =>
      it.ResponsibilityId === row.ResponsibilityId
        ? {
            ...it,
            Checked: wantToCheck ? 1 : 0,
            CheckedBy: wantToCheck ? person : null,
            CheckedAt: wantToCheck ? new Date().toISOString() : null, // keep ISO; display with toISTDateTime
          }
        : it
    ));

    try {
      await axiosInstance.patch('/api/rr/check', {
        responsibilityId: row.ResponsibilityId,
        workDate: row.WorkDate,
        checked: wantToCheck,
        user: person,
      });
      // Optionally reload for absolute sync:
      // await loadData();
    } catch (e) {
      console.error('Failed to toggle checkpoint', e);
      // revert on error
      setItems(prev => prev.map(it =>
        it.ResponsibilityId === row.ResponsibilityId
          ? { ...it, Checked: row.Checked, CheckedBy: row.CheckedBy, CheckedAt: row.CheckedAt }
          : it
      ));
      if (evt && evt.target) evt.target.checked = currentlyChecked;
      alert('Failed to update, please try again.');
    } finally {
      setPendingId(null);
    }
  };

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? 'sidebar-container' : 'sidebar-hidden'}>
        <Sidebar />
      </div>

      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-3" style={{ height: '-webkit-fill-available' }}>
          <h3 className="mb-3">Today’s Checkpoints</h3>
          <div className="mb-2 text-muted">
            Person: <strong>{person || '—'}</strong> &nbsp;|&nbsp; Date: <strong>{todayStr}</strong>
          </div>

          <button className="btn btn-sm btn-outline-secondary mb-3" onClick={loadData}>
            Refresh
          </button>

          {loading ? (
            <div className="text-muted">Loading…</div>
          ) : items.length === 0 ? (
            <div className="alert alert-info">No responsibilities found.</div>
          ) : (
            <div className="list-group">
              {items.map(row => (
                <label key={row.ResponsibilityId} className="list-group-item d-flex align-items-start">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={row.Checked === 1}
                    onChange={(e) => handleToggle(row, e.target.checked, e)}
                    disabled={pendingId === row.ResponsibilityId}
                    title={
                      row.Checked === 1
                        ? `Checked by ${row.CheckedBy || ''} at ${toISTDateTime(row.CheckedAt) || ''}`
                        : 'Mark done'
                    }
                  />
                  <div>
                    <div className="fw-semibold">{row.Responsibility}</div>
                    <small className="text-muted">#{row.RespNo}</small>
                    {row.Checked ? (
                      <div className="text-success small mt-1">
                        ✔ Checked by {row.CheckedBy} at {toISTDateTime(row.CheckedAt)}
                      </div>
                    ) : null}
                  </div>
                </label>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default RRCheckPoints;